import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { get, post, fmtTime } from "@/lib/api";

export default function NudgeSection() {
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => get("/nudges/preview").then((r) => r.ok && setD(r.data));
  useEffect(() => { load(); }, []);

  async function act(path, confirmText) {
    if (confirmText && !window.confirm(confirmText)) return;
    setBusy(true); setMsg("");
    const r = await post(path);
    setBusy(false);
    setMsg(r.ok ? (r.data.results ? `Sent ${r.data.results.filter((x) => x.ok).length} of ${r.data.results.length} emails.` : "Done.") : r.data.error || "Failed.");
    load();
  }

  if (!d) return <p className="muted">Loading nudges…</p>;
  const total = d.emails.reduce((a, e) => a + e.proposals.length, 0);
  return (
    <section className="nudge" data-testid="nudge-section">
      <h4><Mail size={13} /> Weekly proposal nudge</h4>
      <p className="muted">Thursdays 09:30 IST · open proposals not moved for {d.idle_days}+ days · CC {d.cc.join(", ") || "—"}</p>
      <dl>
        <dt>Next send</dt><dd data-testid="nudge-next-run">{fmtTime(d.next_run)}</dd>
        <dt>Last sent</dt><dd data-testid="nudge-last-run">{d.last_run ? `${d.last_run._id} · ${d.last_run.trigger}` : "never"}</dd>
        <dt>This week</dt><dd data-testid="nudge-summary">{d.emails.length} emails · {total} proposals</dd>
      </dl>
      <ul className="nlist" data-testid="nudge-recipients">
        {d.emails.map((e) => (
          <li key={e.owner}><b>{e.owner}</b><small>{e.to.join(", ")}{e.cc.length ? ` · cc ${e.cc.join(", ")}` : ""}</small><span>{e.proposals.length}</span></li>
        ))}
        {d.emails.length === 0 && <li className="muted">Nothing idle this week.</li>}
      </ul>
      <div className="nbtns">
        <button className="ghost" disabled={busy} onClick={() => act("/nudges/test")} data-testid="nudge-test-button">Send me a test copy</button>
        <button className="ghost" disabled={busy || !d.emails.length}
          onClick={() => act("/nudges/send", `Send this week's ${d.emails.length} nudge emails to the owners now (CC ${d.cc.join(", ")})? It won't send again this week.`)}
          data-testid="nudge-send-button">Send this week's now</button>
      </div>
      {msg && <p className="muted" data-testid="nudge-message">{msg}</p>}
    </section>
  );
}
